import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import SelectPicker from "rsuite/esm/SelectPicker";
import Modal from "rsuite/esm/Modal";
import Button from "rsuite/esm/Button";
import { useLocation } from "react-router-dom";
import { getCookie } from "../../../common/Utility";
import useFetchPost from "../../hooks/useFetchPost";

const RaiseCustomInvoiceNew = ({ data, setActionColData, refetchAgGrid }) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [product, setProduct] = useState("");
  const [isDeal, setIsDeal] = useState(false);
  const [urlEndpoint, setUrlEndpoint] = useState("");

  const [errors, setErrors] = useState({});
  const [productList, setProductList] = useState([]);
  const [noProductError, setNoProductError] = useState("");

  console.log("data in raise invoice modal", data);

  let user_uuid = getCookie("muvi_useruuid");
  // Parse query parameters for url encrypt and dcrypt

  const { fetchPostData } = useFetchPost();

  function isInteger(value) {
    const integerRegex = /^\d+$/;
    return integerRegex.test(value);
  }

  const getProduct = async (customer_id, data) => {
    if (isInteger(customer_id)) {
      let requestBody = {
        app_token: customer_id,
        debug: true,
        enterprise_api_gateway_url: data.enterprise_api_gateway_url,
        studio_id: customer_id,
      };
      try {
        const responseData = await fetchPostData(
          `${process.env.REACT_APP_CRM}/muvi5/view-details`,
          requestBody,
        );

        if (responseData && responseData.data[0]) {
          setNoProductError("");
          let customerType = responseData.data[0].customer_type;
          setProductList([
            {
              product_key: "49F37046FCD84520895FC18A4F5BFC8B",
              product_name: "Muvi One (Classic)",
              customer_type: customerType,
            },
          ]);
          setUrlEndpoint("/muvi5/raise-custom-invoice");
        } else {
          setNoProductError("No products are available in this account.");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    } else {
      let requestBody = {
        app_token: customer_id,
        debug: true,
      };
      try {
        const responseData = await fetchPostData(
          `${process.env.REACT_APP_CRM}/muvi6/crm-data`,
          requestBody,
        );
        if (responseData.code == 200) {
          const products = responseData.data.getCrmData.user_details.products;
          const productKeys =
            products !== null ? products.map((product) => product) : [];
          setProductList(productKeys);
          setNoProductError(
            products === null
              ? "No products are available in this account."
              : "",
          );
          setUrlEndpoint("/muvi6/raise-custom-invoice");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
    setActionColData((prevState) => ({
      ...prevState,
      openModal: "",
      raiseCustomInvoiceModalData: {},
    }));
    setProduct("");
    setTitle("");
    setDescription("");
    setAmount("");
    setProductList([]);
    setErrors({});
  };

  //form validation with data set
  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const handleSelectChange = (value) => {
    setProduct(value);
  };

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setOpen(true);
      setAmount(
        data.milestone_amount != null && data.milestone_amount !== undefined
          ? data.milestone_amount
          : 0,
      );

      setIsDeal(
        data.isDeal != null && data.isDeal !== undefined ? data.isDeal : false,
      );

      if (data.isDeal) {
        if (data.customer_id) {
          getProduct(data.customer_id, data);
        }
      }
    }
  }, [data]);

  // Function to handle data submission
  const handleSubmit = async () => {
    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      if (!data.customer_id) {
        toast.error("Unable to fetch customer_id for invoice.");
        return;
      }
      // Submit form data
      const postData = {
        product_key: data && data.isDeal ? product : data.product_key,
        user_uuid: data && data.customer_user_uuid,
        customer_id: data.customer_id,
        item_name: title,
        item_description: description,
        invoice_amount: amount,
        is_deal: data && data.isDeal ? data.isDeal : false,
        milestone_uuid: data && data.milestone_uuid ? data.milestone_uuid : "",
        muvi_useruuid: user_uuid,
        mautic_id: data && data.mautic_id ? data.mautic_id : "",
      };

      let crmStagingUrl = process.env.REACT_APP_CRM + urlEndpoint;
      let responseData;
      try {
        responseData = await fetchPostData(crmStagingUrl, postData);
      } catch (error) {
        console.error("Error:", error);
      }
      if (responseData && responseData.code == 200) {
        refetchAgGrid();
        toast.success("Invoice Submitted Successfully.");
        handleClose();
      } else {
        const errorMessage =
          responseData && responseData.message
            ? responseData.message
            : "An error occurred";
        toast.error(errorMessage);
        console.warn("Something went wrong .in change to muvi ownership");
      }
    } else {
      setErrors(errors);
    }
  };

  const isValidProduct = (value) => {
    const foundProduct = productList.find(
      (product) => product.product_key === value,
    );
    if (foundProduct) {
      const customerType = foundProduct.customer_type;
      if (customerType !== "Lead" && customerType !== "Customer") {
        setNoProductError(
          `This product has a customer type of "${customerType}", which is not allowed.`,
        );
        return false;
      } else {
        return true;
      }
    }
  };
  const validateForm = () => {
    let errors = {};
    if (isDeal) {
      if (!product.trim()) {
        errors.product = "Product is required";
      } else if (!isValidProduct(product)) {
        errors.product = noProductError;
      }
    }

    if (!title.trim()) {
      errors.title = "Title is required";
    }
    if (!description.trim()) {
      errors.description = "Description is required";
    }
    if (!amount) {
      errors.amount = "Amount is required";
    } else if (isNaN(amount)) {
      errors.amount = "Amount must be a number";
    }
    return errors;
  };

  return (
    <Modal open={open} onClose={handleClose} size="sm">
      <Modal.Header>
        <Modal.Title>Raise Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          {isDeal && (
            <div className="form-group">
              <label className="control-label">Product</label>
              <SelectPicker
                data={productList.map((item) => {
                  return {
                    label: item.product_name,
                    value: item.product_key,
                  };
                })}
                name="product"
                value={product}
                onChange={handleSelectChange}
                style={{
                  width: "100%",
                  zIndex: 1050,
                }}
                block={true}
                searchable={false}
                placeholder="Select Product"
              />
              <p className="text-danger" style={{ marginTop: "7px" }}>
                {noProductError}
              </p>
              {errors.title && <p className="text-danger">{errors.product}</p>}
            </div>
          )}

          <div className="form-group">
            <label className="control-label">Title</label>
            <input
              type="text"
              className="form-control"
              id="title"
              value={title}
              onChange={handleTitleChange}
            />

            {errors.title && (
              <p className="text-danger" style={{ marginTop: "7px" }}>
                {errors.title}
              </p>
            )}
          </div>
          <div className="form-group">
            <label className="control-label">Description</label>
            <input
              type="text"
              className="form-control"
              id="description"
              value={description}
              onChange={handleDescriptionChange}
            />
            {errors.description && (
              <p className="text-danger" style={{ marginTop: "7px" }}>
                {errors.description}
              </p>
            )}
          </div>
          <div className="form-group">
            <label className="control-label">Amount ($)</label>
            <input
              type="text"
              className="form-control"
              id="amount"
              value={amount}
              onChange={handleAmountChange}
              onInput={(event) => {
                event.target.value = event.target.value.replace(/[^0-9]/g, "");
              }}
              disabled={data && data.isDeal ? true : false}
            />
            {errors.amount && (
              <p className="text-danger" style={{ marginTop: "7px" }}>
                {errors.amount}
              </p>
            )}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} appearance="default">
          Close
        </Button>
        <Button onClick={handleSubmit} appearance="primary">
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RaiseCustomInvoiceNew;


// WEBPACK FOOTER //
// ./src/components/crm/deals/components/RaiseCustomInvoice.js